var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpecialsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#1D1D22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.68.779 18.115 1.8a.099.099 0 0 1 .084.084l1.05 7.35a.099.099 0 0 1-.028.085L9.32 19.22a.098.098 0 0 1-.14 0L.78 10.82a.098.098 0 0 1 0-.14L10.68.78zm3.37 2.723a2.44 2.44 0 0 0-1.73.717 2.44 2.44 0 0 0-.717 1.73c0 .627.24 1.253.717 1.73a2.44 2.44 0 0 0 1.73.718 2.44 2.44 0 0 0 1.731-.717 2.44 2.44 0 0 0 .717-1.73 2.44 2.44 0 0 0-.717-1.731 2.44 2.44 0 0 0-1.73-.717z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialsIcon);
export default __webpack_public_path__ + "static/media/specials-icon.96c8e73dff7a41f0caa075d36e58852e.svg";
export { ForwardRef as ReactComponent };